import { Action } from 'redux';
import { EligibilityResponsePayload } from '../interfaces/eligibility.interface';
import { OnExchangeApplicationStatus, OnExchangeEnrollResponse } from '../interfaces/on-exchange-enrollment.response-payload.interface';

export interface ProspectState {
  prospectId: string;
  selectedMonthlyAptcForProspect: number;
  individualResponsibilityAmount: string;
  appliedAPTC: number;
  appStatus: OnExchangeApplicationStatus;
  data: EligibilityResponsePayload;
  ffmData: OnExchangeEnrollResponse;
}
export interface OnExchangeEligibilityStateStructure {
  currentProspectId: string;
  prospects: ProspectState[];
}
const INITIAL_STATE: OnExchangeEligibilityStateStructure = {
  currentProspectId: null,
  prospects: []
};

const SET_CURRENT_PROSPECT_ID = 'SET_CURRENT_PROSPECT_ID';
const SET_SELECTED_MONTHLY_TAX_CREDIT = 'SET_SELECTED_MONTHLY_TAX_CREDIT';
const SET_APP_STATUS = 'SET_APP_STATUS';
const SET_DATA = 'SET_DATA';
const SET_FFM_DATA = 'SET_FFM_DATA';
const SET_INDIVIDUAL_RESPONSIBILITY_AMOUNT = 'SET_INDIVIDUAL_RESPONSIBILITY_AMOUNT';
const RESET_STATE_ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME = 'RESET_STATE-ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME';

export class OnExchangeEligibilityAction implements Action {
  type: string;

  prospectId: string;

  selectedMonthlyAptcForProspect?: number;
  individualResponsibilityAmount?: string;
  appliedAPTC?: number;

  data?: EligibilityResponsePayload;
  ffmData?: OnExchangeEnrollResponse;
  appStatus?: OnExchangeApplicationStatus;
}

export function setCurrentProspectId(prospectId: string): OnExchangeEligibilityAction {
  return { type: SET_CURRENT_PROSPECT_ID, prospectId };
}
export function setSelectedMonthlyAptcForProspect(prospectId: string, selectedMonthlyAptcForProspect: number): OnExchangeEligibilityAction {
  return { type: SET_SELECTED_MONTHLY_TAX_CREDIT, prospectId, selectedMonthlyAptcForProspect};
}
export function setData(prospectId: string, data: EligibilityResponsePayload): OnExchangeEligibilityAction {
  return { type: SET_DATA, prospectId, data};
}
export function setAppStatus(prospectId: string, appStatus: OnExchangeApplicationStatus): OnExchangeEligibilityAction {
  return { type: SET_APP_STATUS, prospectId, appStatus};
}
export function setFFMData(prospectId: string, ffmData: OnExchangeEnrollResponse): OnExchangeEligibilityAction {
  return { type: SET_FFM_DATA, prospectId, ffmData};
}
export function setIndividualResponsibilityAmount(
  prospectId: string,
  individualResponsibilityAmount: string,
  appliedAPTC: number
): OnExchangeEligibilityAction {
  return { type: SET_INDIVIDUAL_RESPONSIBILITY_AMOUNT, prospectId, individualResponsibilityAmount, appliedAPTC };
}
export function resetStateOnExchangeEligibilityReducerName(prospectId: string): OnExchangeEligibilityAction {
  return { type: RESET_STATE_ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME, prospectId };
}

export const ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME = 'OnExchangeEligibility';
export function OnExchangeEligibility(
  state: OnExchangeEligibilityStateStructure = INITIAL_STATE,
  action: OnExchangeEligibilityAction
) {

  /** Clearly not interacting with these dispatches */
  if (!action.prospectId) { return state; }

  const copiedState: OnExchangeEligibilityStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));

  /**
   * We'll operate on the value of copied state, accessing the matched prospect,
   * return state if no match found
   */
  let matchedProspectIndex = null;
  let matchedProspect: ProspectState;
  const doesProspectExist = copiedState.prospects.some( (p, i)  => {
    if (p.prospectId === action.prospectId) {
      matchedProspect = p;
      matchedProspectIndex = i;
      return true;
    }
  });

  if (!doesProspectExist) {
    copiedState.prospects.push({
      prospectId: action.prospectId,
      selectedMonthlyAptcForProspect: null,
      individualResponsibilityAmount: null,
      appliedAPTC: null,
      appStatus: null,
      data: null,
      ffmData: null
    });
    matchedProspect = copiedState.prospects[copiedState.prospects.length - 1];
  }

  switch (action.type) {

    case SET_CURRENT_PROSPECT_ID:
      copiedState.currentProspectId = action.prospectId;
      return Object.assign({}, state, copiedState);

    case SET_SELECTED_MONTHLY_TAX_CREDIT:
      matchedProspect.selectedMonthlyAptcForProspect = action.selectedMonthlyAptcForProspect;
      return Object.assign({}, state, copiedState);

    case SET_APP_STATUS:
      matchedProspect.appStatus = action.appStatus;
      return Object.assign({}, state, copiedState);

    case SET_DATA:
      matchedProspect.data = action.data;
      return Object.assign({}, state, copiedState);

    case SET_FFM_DATA:
      matchedProspect.ffmData = action.ffmData;
      return Object.assign({}, state, copiedState);

    case SET_INDIVIDUAL_RESPONSIBILITY_AMOUNT:
      matchedProspect.individualResponsibilityAmount = action.individualResponsibilityAmount;
      matchedProspect.appliedAPTC = action.appliedAPTC;
      return Object.assign({}, state, copiedState);

    case RESET_STATE_ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME:
      copiedState.prospects.splice(matchedProspectIndex, 1);
      return Object.assign({}, state, copiedState);

    default:
      return state;
  }
}
